import React, { useState, useContext } from 'react';
import MatchesListHeader from '../components/Matches/MatchesListHeader';
import MatchesTopHeader from '../components/Matches/MatchesTopHeader';
import MatchesList from '../components/Matches/MatchesList';
import SideTeamNews from '../components/Matches/SideTeamNews';
import SideCurrentMatches from '../components/Matches/SideCurrentMatches';
import { DataContext } from '../context/data-context';

function Matches() {
  const { currentSeason } = useContext(DataContext);
  const [orderBy, setOrderBy] = useState('round');
  const [team, setTeam] = useState('all');
  const [season, setSeason] = useState(currentSeason);
  const [round, setRound] = useState('all');

  return (
    <>
      <div className="col-12 col-xl-8">
        <div className="row px-3 px-md-4 mb-3">
          <MatchesTopHeader setOrderBy={setOrderBy} orderBy={orderBy} />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="data-container">
              <MatchesListHeader
                setSeason={setSeason}
                season={season}
                team={team}
                setTeam={setTeam}
                round={round}
                setRound={setRound}
                hideRoundFilter={orderBy === 'date'}
              />
              <MatchesList
                season={season}
                orderBy={orderBy}
                team={team}
                round={round}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12" />
        </div>
      </div>
      <div className="col-4 d-none d-xl-block">
        <p className="heading-h3 text-color-primary-white mt-2 mb-4 pb-2 px-4">AKTUELLA MATCHER</p>
        <div className="col-12">
          <div className="data-container data-container--gradient">
            <SideCurrentMatches />
          </div>
        </div>
        <div className="col-12 mt-5">
          <SideTeamNews />
        </div>
      </div>
    </>
  );
}

export default Matches;
